import { render, staticRenderFns } from "./article2.vue?vue&type=template&id=363cd7db&scoped=true"
import script from "./article2.vue?vue&type=script&lang=js"
export * from "./article2.vue?vue&type=script&lang=js"
import style0 from "./article2.vue?vue&type=style&index=0&id=363cd7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363cd7db",
  null
  
)

export default component.exports